"use strict";

var _interopRequireDefault3 = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault3(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault3(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault3(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault3(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault3(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault3(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault3(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault3(require("@babel/runtime/helpers/defineProperty"));

var _interopRequireDefault2 = _interopRequireDefault3(require("@babel/runtime/helpers/interopRequireDefault"));

var _autobindDecorator = _interopRequireDefault3(require("autobind-decorator"));

var _Button = _interopRequireDefault3(require("../../Button"));

var _createId = _interopRequireDefault3(require("../../utils/createId"));

var _filterDOMProps = _interopRequireDefault3(require("../../utils/filterDOMProps"));

var _intl = require("../../utils/intl");

var _propTypes = _interopRequireDefault3(require("prop-types"));

var _react = _interopRequireDefault3(require("react"));

var _FocusManager = require("../../utils/FocusManager");

require("../style/index.css");

var _class, _class2, _temp;

var intlMessages = {
  "cs-CZ": (0, _interopRequireDefault2["default"])(require("./../intl/cs-CZ.json"))["default"],
  "da-DK": (0, _interopRequireDefault2["default"])(require("./../intl/da-DK.json"))["default"],
  "de-DE": (0, _interopRequireDefault2["default"])(require("./../intl/de-DE.json"))["default"],
  "en-US": (0, _interopRequireDefault2["default"])(require("./../intl/en-US.json"))["default"],
  "es-ES": (0, _interopRequireDefault2["default"])(require("./../intl/es-ES.json"))["default"],
  "fi-FI": (0, _interopRequireDefault2["default"])(require("./../intl/fi-FI.json"))["default"],
  "fr-FR": (0, _interopRequireDefault2["default"])(require("./../intl/fr-FR.json"))["default"],
  "hu-HU": (0, _interopRequireDefault2["default"])(require("./../intl/hu-HU.json"))["default"],
  "it-IT": (0, _interopRequireDefault2["default"])(require("./../intl/it-IT.json"))["default"],
  "ja-JP": (0, _interopRequireDefault2["default"])(require("./../intl/ja-JP.json"))["default"],
  "ko-KR": (0, _interopRequireDefault2["default"])(require("./../intl/ko-KR.json"))["default"],
  "nb-NO": (0, _interopRequireDefault2["default"])(require("./../intl/nb-NO.json"))["default"],
  "nl-NL": (0, _interopRequireDefault2["default"])(require("./../intl/nl-NL.json"))["default"],
  "pl-PL": (0, _interopRequireDefault2["default"])(require("./../intl/pl-PL.json"))["default"],
  "pt-BR": (0, _interopRequireDefault2["default"])(require("./../intl/pt-BR.json"))["default"],
  "ru-RU": (0, _interopRequireDefault2["default"])(require("./../intl/ru-RU.json"))["default"],
  "sv-SE": (0, _interopRequireDefault2["default"])(require("./../intl/sv-SE.json"))["default"],
  "tr-TR": (0, _interopRequireDefault2["default"])(require("./../intl/tr-TR.json"))["default"],
  "uk-UA": (0, _interopRequireDefault2["default"])(require("./../intl/uk-UA.json"))["default"],
  "zh-CN": (0, _interopRequireDefault2["default"])(require("./../intl/zh-CN.json"))["default"],
  "zh-TW": (0, _interopRequireDefault2["default"])(require("./../intl/zh-TW.json"))["default"]
};
var formatMessage = (0, _intl.messageFormatter)(intlMessages);

var CoachMarkPopover = (0, _autobindDecorator["default"])(_class = (_temp = _class2 =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(CoachMarkPopover, _React$Component);

  function CoachMarkPopover(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, CoachMarkPopover);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(CoachMarkPopover).call(this, props));
    _this.coachmarkId = (0, _createId["default"])();
    return _this;
  }

  (0, _createClass2["default"])(CoachMarkPopover, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.trapFocus) {
        this._trapFocusTimeout = requestAnimationFrame(function () {
          if (_this2.coachmarkRef && !_this2.coachmarkRef.contains(document.activeElement)) {
            _this2.coachmarkRef.focus();
          }
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._trapFocusTimeout) {
        cancelAnimationFrame(this._trapFocusTimeout);
      }
    }
  }, {
    key: "onFocus",
    value: function onFocus(e) {
      if (this.props.onFocus) {
        this.props.onFocus(e);
      }

      if (this.props.trapFocus) {
        (0, _FocusManager.trapFocus)(this, e);
      }
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(e) {
      if (this.props.onKeyDown) {
        this.props.onKeyDown(e); // Do nothing if stopPropagation has been called on event after onKeyDown prop executes.

        if (e.isPropagationStopped && e.isPropagationStopped()) {
          return;
        }
      }

      if (this.props.trapFocus) {
        (0, _FocusManager.trapFocus)(this, e);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          title = _this$props.title,
          confirmLabel = _this$props.confirmLabel,
          onConfirm = _this$props.onConfirm,
          cancelLabel = _this$props.cancelLabel,
          onCancel = _this$props.onCancel,
          disableProgress = _this$props.disableProgress,
          currentStep = _this$props.currentStep,
          totalSteps = _this$props.totalSteps,
          image = _this$props.image,
          children = _this$props.children,
          _this$props$id = _this$props.id,
          id = _this$props$id === void 0 ? this.coachmarkId : _this$props$id,
          tabIndex = _this$props.tabIndex,
          _this$props$imageAlt = _this$props.imageAlt,
          imageAlt = _this$props$imageAlt === void 0 ? '' : _this$props$imageAlt,
          autoFocus = _this$props.autoFocus,
          trapFocus = _this$props.trapFocus,
          otherProps = (0, _objectWithoutProperties2["default"])(_this$props, ["title", "confirmLabel", "onConfirm", "cancelLabel", "onCancel", "disableProgress", "currentStep", "totalSteps", "image", "children", "id", "tabIndex", "imageAlt", "autoFocus", "trapFocus"]);
      disableProgress = disableProgress || typeof currentStep !== 'number' || typeof totalSteps !== 'number'; // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions

      return _react["default"].createElement("div", (0, _extends2["default"])({}, (0, _filterDOMProps["default"])(otherProps), {
        className: "spectrum-CoachMarkPopover",
        role: "dialog",
        "aria-labelledby": "".concat(id, "-header"),
        "aria-describedby": "".concat(id, "-content"),
        id: id,
        ref: function ref(c) {
          return _this3.coachmarkRef = c;
        },
        onFocus: this.onFocus,
        onKeyDown: this.onKeyDown,
        tabIndex: trapFocus && tabIndex == null ? 1 : tabIndex
      }), image && _react["default"].createElement("img", {
        src: image,
        alt: imageAlt,
        className: "spectrum-CoachMarkPopover-image"
      }), _react["default"].createElement("div", {
        className: "spectrum-CoachMarkPopover-header",
        id: "".concat(id, "-header")
      }, _react["default"].createElement("div", {
        className: "spectrum-CoachMarkPopover-title"
      }, title), !disableProgress && _react["default"].createElement("div", {
        className: "spectrum-CoachMarkPopover-step"
      }, formatMessage('steps', {
        currentStep: currentStep,
        totalSteps: totalSteps
      }))), _react["default"].createElement("div", {
        className: "spectrum-CoachMarkPopover-content",
        id: "".concat(id, "-content")
      }, children), _react["default"].createElement("div", {
        className: "spectrum-CoachMarkPopover-footer"
      }, cancelLabel && _react["default"].createElement(_Button["default"], {
        quiet: true,
        onClick: onCancel,
        autoFocus: !confirmLabel ? autoFocus : null
      }, cancelLabel), confirmLabel && _react["default"].createElement(_Button["default"], {
        variant: "primary",
        onClick: onConfirm,
        autoFocus: autoFocus
      }, confirmLabel)));
    }
  }]);
  return CoachMarkPopover;
}(_react["default"].Component), (0, _defineProperty2["default"])(_class2, "propTypes", {
  /** Title */
  title: _propTypes["default"].string.isRequired,

  /**
   * Text of the primary button.
   * Required if using Coachmarks on their own. Can't use `.required`
   * though because Tour can provide a default.
   **/
  confirmLabel: _propTypes["default"].string,

  /** Event Handler for the confirm button */
  onConfirm: _propTypes["default"].func,

  /** Text of the secondary button */
  cancelLabel: _propTypes["default"].string,

  /** Event Handler for the cancel button */
  onCancel: _propTypes["default"].func,

  /** Hide progress */
  disableProgress: _propTypes["default"].bool,

  /** Url to an image to display */
  image: _propTypes["default"].string,

  /** Text alternative for image */
  imageAlt: _propTypes["default"].string,

  /** Current step */
  currentStep: _propTypes["default"].number,

  /** Total amount of steps */
  totalSteps: _propTypes["default"].number,

  /** Whether to autofocus on mount */
  autoFocus: _propTypes["default"].bool,

  /** Whether to trapFocus within coachmark */
  trapFocus: _propTypes["default"].bool,

  /** tabIndex property to manage how coachmark popover is included in the keyboard navigation order */
  tabIndex: _propTypes["default"].number,

  /** String that will override the default id generated by the instance */
  id: _propTypes["default"].string
}), (0, _defineProperty2["default"])(_class2, "defaultProps", {
  autoFocus: true,
  imageAlt: '',
  trapFocus: true
}), _temp)) || _class;

exports["default"] = CoachMarkPopover;